import ApiService from "../../global/service";

export default class LibraryService {

    _getModels = (responseHandler, errorHandler) => ApiService.get("/v1/auth/me", {}, responseHandler, errorHandler, process.env.REACT_APP_AUTH_API_URL)

}